import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "trash",
  "use": "trash-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 22\" id=\"trash\"><defs><style>#trash .cls-1{fill-rule:evenodd}</style></defs><path class=\"cls-1\" d=\"M6 17.874a.676.676 0 0 0 .66-.687V9.624a.665.665 0 1 0-1.33 0v7.563a.678.678 0 0 0 .67.687zm4 0a.676.676 0 0 0 .66-.687V9.624a.665.665 0 1 0-1.33 0v7.563a.678.678 0 0 0 .67.687zm4 0a.676.676 0 0 0 .66-.687V9.624a.665.665 0 1 0-1.33 0v7.563a.678.678 0 0 0 .67.687zm4-11.687h1.33V5.5H20v-.687a2.716 2.716 0 0 0-2.67-2.75h-2.76A2.679 2.679 0 0 0 12 0H8a2.691 2.691 0 0 0-2.58 2.063H2.66A2.707 2.707 0 0 0 0 4.813V5.5h.66v.688H2V19.25A2.707 2.707 0 0 0 4.66 22h10.67A2.716 2.716 0 0 0 18 19.25V6.187zM8 1.375h4a1.31 1.31 0 0 1 1.14.687H6.85A1.325 1.325 0 0 1 8 1.375zm8.66 17.874a1.356 1.356 0 0 1-1.33 1.375H4.66a1.434 1.434 0 0 1-1.42-1.375l.09-13.062h13.33v13.062zm.67-15.812a1.35 1.35 0 0 1 1.33 1.375H1.33a1.357 1.357 0 0 1 1.33-1.375h14.67z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/trash.svg
// module id = Ubxc
// module chunks = 6